// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__nd-uy","slideDown":"Toast_slideDown__SP0DO","toastOut":"Toast_toastOut__4TFFD","slideUp":"Toast_slideUp__zm-T+","icon":"Toast_icon__QI9U5"};